module.exports = __webpack_public_path__ + "static/media/f1799750-0952-403f-8108-b2402eed0f62.d90b3fe2.woff";